import { z } from 'zod';
import qs from './utils/query-string';
import * as SearchApi from './interfaces/search';
export class SearchClient {
    constructor(authenticatedClient) {
        this.authenticatedClient = authenticatedClient;
        this.searchKols = async (params) => {
            return this.authenticatedClient.get(`/search/kol?${qs.stringify(params)}`).then(r => r.data);
        };
        this.searchHcpsByName = async (params) => {
            return this.authenticatedClient.get(`/search/hcp?${qs.stringify(params)}`).then(r => r.data);
        };
        this.searchHcpsByLocation = async (params) => {
            return this.authenticatedClient.get(`/search/hcp/location?${qs.stringify(params)}`).then(r => r.data);
        };
        this.searchLocation = async (params) => {
            return this.authenticatedClient.get(`/search/location?${qs.stringify(params)}`).then(r => r.data);
        };
        this.searchTags = async (params) => {
            const query = qs.stringify({
                query: params.query,
            });
            return this.authenticatedClient.get(`/tags?${query}`).then(r => SearchApi.SearchTags.responseSchema.parse(r.data));
        };
    }
}
export const responseSchema = z.object({
    results: z.object({
        id: z.number(),
        name: z.string(),
    }).required(),
});
export default SearchClient;
